// Wzorzec „Standard” pierwszy na liście wzorców (decyzja właściciela 2026-11-04, panel 1.5.2). API nie sortuje wzorców
// (kolejność naturalna Mongo), a pierwszy element listy jest domyślnym wyborem w oknie „Nowa ankieta ze wzorca”.
// Na początek idzie wzorzec o _id seedowego „Standard” (ten sam _id ma na sztywno ankieta kursanta, options.js:28),
// a gdy go brak - pierwszy o nazwie „Standard”. Reszta (także drugi „Standard”) zostaje w dotychczasowej kolejności.
export const STANDARD_TEMPLATE_ID = '5e01f138dee919717c9f6321'
export const STANDARD_TEMPLATE_NAME = 'Standard'

const normalizedName = (name) => String(name === undefined || name === null ? '' : name).trim()

export const standardFirst = (items, { getId = (item) => item && item._id, getName = (item) => item && item.name } = {}) => {
  if (!Array.isArray(items)) return items
  let index = items.findIndex((item) => String(getId(item)) === STANDARD_TEMPLATE_ID)
  if (index < 0) index = items.findIndex((item) => normalizedName(getName(item)) === STANDARD_TEMPLATE_NAME)
  if (index <= 0) return items.slice()
  return [items[index], ...items.slice(0, index), ...items.slice(index + 1)]
}

// opcje pola „Rodzaj ankiety” z API: { value: _id, label: nazwa }
export const standardFirstOptions = (options) => standardFirst(options, {
  getId: (option) => option && option.value,
  getName: (option) => option && option.label,
})
